export const fields = [
  { name: "list", type: "array", defaultValue: [], required: true },
];

export const label = "SubTopics"
